module.exports = __webpack_public_path__ + "img/schedule.707e9db2.svg";